<template>
  <div class="text-center">
    <v-app-bar flat color="white">
      <v-btn fab text x-small color="black" @click="$emit('close')">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

<!--    <popup-header @clickClose="historyBack"></popup-header>-->
    <v-row class="d-flex ma-3 mt-5 text-left">
      <v-col class="pa-0 mx-4">
        <logo v-if="this.$store.getters.GET_USER_DATA.ssnEnterCd == '10'" :width="125" :height="24" />
        <logo-bgf v-else :width="68" :height="24" />
      </v-col>
    </v-row>
    <!-- 제목 -->
    <v-row class="title-wrap mx-6 my-5">
      <v-col
        cols="12"
        class="pa-0 mt-5 text-left text-h5 color-light-grey font-weight-medium"
      >
        <span class="font-weight-bold color-dark-grey">{{
          $store.getters.GET_USER_DATA.ssnName
        }}</span
        >님<br />
        인증코드를 입력하세요.
      </v-col>
    </v-row>

    <v-row
      v-if="!isSended"
      class="d-flex justify-space-between pa-0 mx-6 my-0 overflow-auto"
    >
      <v-col class="pa-0 mr-2">
        <v-text-field
          v-model="authenticateData.confirmPwd"
          placeholder="인증코드를 입력해주세요"
          outlined
          class="pa-0"
        ></v-text-field>
      </v-col>
      <v-col class="pa-0 flex-grow-0"
        ><v-btn
          @click="sendSecondAuthenticateCode"
          type="submit"
          class="elevation-0 rounded-lg text-body py-2 btn-s-grey white--text font-weight-light"
          >인증코드 받기</v-btn
        ></v-col
      >
    </v-row>
    <!--인증코드 입력후 화면-->
    <v-row
      v-if="isSended"
      class="d-flex justify-space-between pa-0 mx-6 my-0 overflow-auto"
    >
      <v-col class="pa-0 mr-2">
        <v-text-field
          v-model="authenticateData.confirmPwd"
          placeholder="인증코드를 입력해주세요"
          outlined
          class="pa-0"
          :messages="clock.message"
        >
        </v-text-field>
      </v-col>
      <v-col class="pa-0 flex-grow-0"
        ><v-btn
          @click="sendSecondAuthenticateCode"
          type="submit"
          class="elevation-0 rounded-lg text-body py-2 btn-s-grey white--text font-weight-light"
          >재전송</v-btn
        ></v-col
      >
    </v-row>

    <v-footer fixed app color="white" class="py-6" style="border:none !important; background : none !important;">
      <v-btn
          block
          elevation="0"
          class="btn-fixed btn-green"
          @click="validSecondAuthenticateCode"
      >
        <span class="white--text">확인</span>
      </v-btn>
    </v-footer>

    <!--하단버튼-->
<!--    <v-bottom-navigation-->
<!--      v-model="value"-->
<!--      :input-value="active"-->
<!--      fixed-->
<!--      scroll-threshold="500"-->
<!--      height="96"-->
<!--    >-->
<!--      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">-->
<!--        <v-col cols="12">-->
<!--          <v-btn-->
<!--            block-->
<!--            elevation="0"-->
<!--            class="btn-fixed btn-green"-->
<!--            style="opacity: 70%"-->
<!--            @click="validSecondAuthenticateCode"-->
<!--          >-->
<!--            <span class="white&#45;&#45;text">확인</span>-->
<!--          </v-btn>-->
<!--        </v-col>-->
<!--        &lt;!&ndash;style="opacity: 70%"삭제시 버튼 opacity 100%로 나옴&ndash;&gt;-->
<!--      </v-row>-->
<!--    </v-bottom-navigation>-->

    <v-dialog v-model="dialogData.isShowDialog" width="500">
      <v-card>
        <v-card-title>{{ dialogData.text }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="green"
            class="white--text"
            @click="dialogData.isShowDialog = false"
            >확인</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//import PopupHeader from '@/components/common/PopupHeader.vue';
import LogoBgf from "@/assets/customIcon/LogoBGF.vue";
import Logo from '@/assets/customIcon/Logo.vue';
import { mapGetters } from 'vuex';
import {
  sendSecondAuthenticate,
  validSecondAuthenticate,
} from '@/api/secondAuthenticate';

export default {
  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },
  components: {
    LogoBgf,
    Logo,
 //   PopupHeader,
  },
  data: () => ({
    value: '',
    active: true,
    authenticateData: {
      confirmPwd: '',
    },
    dialogData: {
      isShowDialog: false,
      text: '',
    },
    isSended: false,
    timer: null,
    clock: {
      min: 0,
      sec: 60,
      message: '',
    },
  }),
  methods: {
    historyBack() {
      this.$router.go(-1);
    },
    calcClock() {
      let min = this.clock.min > 10 ? this.clock.min : '0' + this.clock.min;
      let sec = this.clock.sec > 10 ? this.clock.sec : '0' + this.clock.sec;
      return min + ':' + sec;
    },
    sendSecondAuthenticateCode() {
      sendSecondAuthenticate({
        enterCd: this.$store.getters.GET_USER_DATA.ssnEnterCd,
        sabun: this.$store.getters.GET_USER_DATA.ssnSabun,
        userId: this.$store.getters.GET_USER_DATA.id,
        sessionToken: this.$store.getters.GET_SESSION_TOKEN,
      }).then(response => {
        this.dialogData.text = response.data.RSLT_MSG;
        this.dialogData.isShowDialog = true;
        if (response.data.RSLT_CD === '0000') {
          this.clock.min = 0;
          this.clock.sec = 60;
          this.isSended = true;
          this.timer = setInterval(() => {
            if (this.clock.sec === 0) {
              clearInterval(this.timer);
              this.timer = null;
              return;
            }
            this.clock.sec--;
            this.clock.message = this.calcClock();
          }, 1000);
        }
      });
    },
    validSecondAuthenticateCode() {
      validSecondAuthenticate({
        enterCd: this.$store.getters.GET_USER_DATA.ssnEnterCd,
        sabun: this.$store.getters.GET_USER_DATA.ssnSabun,
        confirmPwd: this.authenticateData.confirmPwd,
        userId : this.$store.getters.GET_USER_DATA.id,
        sessionToken : this.$store.getters.GET_SESSION_TOKEN
      }).then(response => {
        this.dialogData.text = response.data.RSLT_MSG;
        this.dialogData.isShowDialog = true;
        if (response.data.RSLT_CD === '0000') {
          clearInterval(this.timer);
          this.timer = null;
          // this.$store.commit(
          //   'SET_SECOND_AUTHENTICATE',
          //   this.$route.query.redirectUrl,
          // );
          // this.$router.push({
          //   path: this.$route.query.redirectUrl,
          // });
          this.$store.commit('SET_SECOND_AUTHENTICATE', true);
          this.$store.commit('SET_SHOW_SECOND_AUTHENTICATE', false);
          const type = this.$store.getters.GET_SECOND_AUTHENTICATE_AFTER_TYPE;
          if(type === 'page'){
            this.$router.push({path : this.$store.getters.GET_REDIRECT_URL});
          }
        }
      });
    },
  },
};
</script>

<style>
.v-btn:not(.v-btn--round).v-size--default {
  height: 48px !important;
  padding: 0 12px !important;
}

.v-text-field--outlined > .v-input__control > .v-input__slot {
  align-items: stretch;
  min-height: 48px !important;
}
.v-application .error--text {
  color: #000 !important;
  caret-color: #000 !important;
}
.theme--light.v-messages {
  color: #dd4a36;
}
</style>
